import { render, staticRenderFns } from "./TeacherForm.vue?vue&type=template&id=8d5345cc&"
import script from "./TeacherForm.vue?vue&type=script&lang=js&"
export * from "./TeacherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports